import {
  FETCH_PAYOUTS_BEGIN,
  FETCH_PAYOUTS_SUCCESS,
  FETCH_PAYOUTS_FAILURE,
} from '../actions/payoutActions';

const initialState = {
  items: [],
  loading: false,
  error: null,
};

export default function payoutReducer(state = initialState, action) {
  switch(action.type) {
    case FETCH_PAYOUTS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_PAYOUTS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.payouts,
        totalItems: action.payload.totalItems,
      };

    case FETCH_PAYOUTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        items: []
      };

    default:
      return state;
  }
}